<app-header></app-header>

@if (redirectUser?.navbarUser?.isUniversalCanvasser && companyName) {
  <div class="retailer-name-banner">
    <span class="retailer-name">{{ companyName }}</span>
  </div>
}
@else {
  <div class="gap100"></div>
}

<div class="container">


  <div class="gap20"></div>
  <div class="row marginTop150">
    <div class="content-container min-height">
      <div class="content">


        <div class="row justify-content-center">


          @if (redirectUser?.navbarUser != undefined && redirectUser?.navbarUser?.deviceInd == 'Y') {
            <div class="col-3"
              >
              <div (click)="redirectFoneyam()">
                <img src="assets/images/FoneYam_icon.png" class="app-selection-images" />
              </div>
            </div>
          }
          @if (redirectUser?.navbarUser != undefined && redirectUser?.navbarUser?.aplusInd == 'Y') {
            <div class="col-3"
              >
              <div (click)="redirectAplus()">
                <img src="assets/images/A_plus_icon.png" class="app-selection-images" />
              </div>
            </div>
          }
          @if (redirectUser?.navbarUser != undefined && redirectUser?.navbarUser?.loanInd == 'Y') {
            <div class="col-3"
              >
              <div (click)="redirectLeads()">
                <img src="assets/images/Capfin_icon.png" class="app-selection-images" />
              </div>
            </div>
          }
          @if (redirectUser?.navbarUser != undefined && (redirectUser?.navbarUser?.aplusInd == 'Y' || redirectUser?.navbarUser?.loanInd == 'Y')) {
            <div class="col-3"
              >
              <div (click)="redirectDocUpload()">
                <img src="assets/images/Doc_Upload_icon.png" class="app-selection-images" />
              </div>
            </div>
          }
          @if (redirectUser?.navbarUser != undefined && redirectUser?.navbarUser?.dashboardInd == 'Y') {
            <div class="col-3"
              >
              <div (click)="redirectMyPerformance()">
                <img src="assets/images/iconMyPerformance.png" class="app-selection-images" />
              </div>
            </div>
          }

          @if (redirectUser?.navbarUser?.deviceInd != 'Y' && redirectUser?.navbarUser?.aplusInd != 'Y' && redirectUser?.navbarUser?.loanInd != 'Y' && redirectUser?.navbarUser?.dashboardInd != 'Y') {
            <p class="unauthorize_app_msg"
              >
            You are not authorized to use this application!</p>
          }

        </div>



      </div>
    </div>
  </div>
</div>